import { render, staticRenderFns } from "./SvgLoader.vue?vue&type=template&id=b8dd062a"
import script from "./SvgLoader.vue?vue&type=script&lang=js"
export * from "./SvgLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports